var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIconStep2Top(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.539,
    height: 81.51,
    viewBox: "0 0 66.539 81.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(-70 -938.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2455",
    "data-name": "Rectangle 2455",
    width: 66.539,
    height: 81.51,
    rx: 5,
    transform: "translate(70 938.49)",
    fill: "#bcc7d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2465",
    "data-name": "Rectangle 2465",
    width: 11.644,
    height: 11.644,
    transform: "translate(88.299 955.125)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2464",
    "data-name": "Rectangle 2464",
    width: 11.644,
    height: 11.644,
    transform: "translate(88.299 973.423)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2466",
    "data-name": "Rectangle 2466",
    width: 11.644,
    height: 11.644,
    transform: "translate(106.597 955.125)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2463",
    "data-name": "Rectangle 2463",
    width: 11.644,
    height: 11.644,
    transform: "translate(106.597 973.423)",
    fill: "#f4f6f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconStep2Top);
export default __webpack_public_path__ + "static/media/footer-icon-step2-top.db3692ab.svg";
export { ForwardRef as ReactComponent };